import gql from 'graphql-tag';

export const integrationOneDriveFragment = gql`
  fragment integrationOneDriveFragment on IntegrationOneDrive {
    dokkioClass
    id
    accountID
    syncFolderRemoteID
    syncFolderPath
  }
`;
export default integrationOneDriveFragment;
